import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Box, Divider, Modal, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { modalContainerStyle } from '~/components/styles';
import { WarningAltIcon } from '~/icons';
import { useAppDispatch } from '~/redux';
import { clearAuthError } from '~/redux/slices/authSlice';

interface AuthErrorModalProps {
  message: string;
  status: number | null;
}

const AuthErrorModal: FC<AuthErrorModalProps> = ({ message, status }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const doesRequireAccess = [401, 403, 404].includes(status!);

  // Clear the error first so AuthChecker stops blocking the Outlet and LogoutPage can mount
  const handleLogout = () => {
    dispatch(clearAuthError());
    navigate('/logout', { replace: true });
  };

  return (
    <Modal open disableAutoFocus>
      <Stack direction="column" sx={modalContainerStyle}>
        <Stack direction="column" p={8}>
          <Stack alignItems="center" direction="row" minHeight={isSmallScreen ? '40vh' : '60vh'}>
            <Stack direction="column" alignItems="start" justifyContent="center" spacing={2} width="100%">
              <Typography variant="h3" sx={{ fontWeight: 950 }}>
                Access unavailable
              </Typography>
              <Typography>{message}</Typography>
              <Typography>
                {doesRequireAccess && 'Please contact your administrator if you think this is a mistake.'}
              </Typography>
            </Stack>
            <Box width="50%" height="50%">
              <WarningAltIcon style={{ width: '100%', height: '100%' }} fill="#0000004c" />
            </Box>
          </Stack>
        </Stack>
        <Divider />
        <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%" p={2}>
          {doesRequireAccess ? (
            <CustomButton
              size="large"
              buttonType="borderless"
              href="https://medtronicprod.service-now.com/it?id=sc_cat_item&sys_id=8c856e58c3b58e107ec5e7deb00131fb"
            >
              Request Access
            </CustomButton>
          ) : (
            <Box />
          )}
          <CustomButton size="large" onClick={handleLogout}>
            Log out
          </CustomButton>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default AuthErrorModal;
